import { IHttpApi } from '@cian/http-api/shared';
import { fetchCreateMessage, ICreateMessageRequest } from '../../repositories/demand/v2/create-message';

export const createMessage = (httpApi: IHttpApi, parameters: ICreateMessageRequest) =>
  fetchCreateMessage({ httpApi, parameters });
